import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { DonutLargeRounded } from '@mui/icons-material';
import { Fragment } from 'react';

import Chart from 'react-apexcharts';

import MainCard from '../../../common/cards/MainCard';
import { subMerchantRevenueChartProps } from '../../variables';
import ChartSkeleton from '../skeletons/ChartSkeleton';

export default function SubMerchantRevenueChart({ isLoading, data }) {
  const theme = useTheme();

  if (isLoading) return <ChartSkeleton height={480} />;

  const grey200 = theme.palette.grey[200];
  const grey500 = theme.palette.grey[500];

  const primary200 = theme.palette.primary[200];
  const primaryDark = theme.palette.primary.dark;
  const secondaryMain = theme.palette.secondary.main;
  const warningMain = theme.palette.warning.main;
  const errorMain = theme.palette.error.main;
  const errorLight = theme.palette.error.light;
  const successLight = theme.palette.success.light;
  const successDark = theme.palette.success.dark;

  // Raw data for transactions.
  const transactions = data.transactionsGroupedBySubMerchant;

  // Handle series for chart
  const series = [];
  const labels = [];

  Object.values(transactions).forEach((ele) => {
    series.push(
      ele.data.reduce((sum, ele) => sum + parseInt(ele.netamount), 0)
    );
    labels.push(ele.name);
  });

  // Handle chart props
  const renderSubMerchantRevenueChartProps = {
    ...subMerchantRevenueChartProps,
    series,
  };
  renderSubMerchantRevenueChartProps.options = {
    ...renderSubMerchantRevenueChartProps.options,
    labels: labels,
    colors: [
      primary200,
      errorLight,
      secondaryMain,
      successDark,
      primaryDark,
      warningMain,
      errorMain,
      successLight,
    ],
    grid: {
      borderColor: grey200,
    },
    tooltip: {
      theme: 'light',
    },
    legend: {
      position: 'bottom',
      labels: {
        colors: grey500,
      },
    },
    fill: {
      opacity: 0.85,
    },
  };

  return (
    <Fragment>
      <MainCard>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <Grid container direction="column" spacing={1}>
                  <Grid item>
                    <Box sx={{ textAlign: 'left' }} height="40px">
                      <Button
                        endIcon={<DonutLargeRounded />}
                        sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
                        size="medium"
                      >
                        <Typography variant="h4">
                          SubMerchants Revenue
                        </Typography>
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} height="544px">
            <Box
              sx={{
                position: 'relative',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <Chart {...renderSubMerchantRevenueChartProps} />
            </Box>
          </Grid>
        </Grid>
      </MainCard>
    </Fragment>
  );
}
